/**
 * Le manifeste que le téléphone lira s'il installe l'application depuis cette
 * page.
 *
 * Le manifeste commun ouvre l'écran de connexion. Depuis l'invitation d'un
 * ouvrier ou le lien de commande d'un client, l'icône doit rouvrir autre
 * chose : l'écran à son nom, ou sa page de commande. L'iPhone ne partage ni
 * session ni mémoire entre Safari et l'application installée : ce que l'icône
 * ouvre doit être écrit dans son adresse de départ, que le manifeste fixe.
 * L'adresse de la page est remplacée par la même, au cas où le téléphone
 * retiendrait celle-ci plutôt que celle du manifeste.
 *
 * @param {string} href adresse du manifeste propre à la page
 * @param {object} [options] réglages
 * @param {string} [options.titre] nom sous l'icône (iPhone)
 * @param {string} [options.depart] adresse que l'icône rouvrira
 */
export function utiliseManifeste(href, { titre, depart } = {}) {
  if (typeof document === 'undefined') return;
  let lien = document.querySelector('link[rel="manifest"]');
  if (!lien) {
    lien = document.createElement('link');
    lien.rel = 'manifest';
    document.head.appendChild(lien);
  }
  lien.href = href;
  if (titre) {
    let meta = document.querySelector('meta[name="apple-mobile-web-app-title"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'apple-mobile-web-app-title';
      document.head.appendChild(meta);
    }
    meta.content = titre.slice(0, 20);
  }
  if (depart && typeof window !== 'undefined' && window.history?.replaceState) {
    try {
      if (window.location.pathname + window.location.search !== depart) {
        window.history.replaceState(window.history.state, '', depart);
      }
    } catch {
      // Adresse inchangée : le manifeste suffit.
    }
  }
}
